module.exports = __webpack_public_path__ + "img/linkedin-logo.f437297d.png";